import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { URLKeys, noddiAsync } from 'noddi-async';
import { NoddiButton } from 'noddi-ui-web';
import { useAuthContext } from 'noddi-web';
import { useState } from 'react';
import { ApiErrorMessageWithTrans } from '../Error/ApiErrorMessageWithTrans';
import { NoddiLoadingScreenWithTrans } from '../Loading/NoddiLoadingScreenWithTrans';
import { Address } from './Address';
import { AddressDialog } from './AddressDialog';

export const Addresses = () => {
  const { getCurrentUserGroupId } = useAuthContext();
  const userGroupId = getCurrentUserGroupId();
  const [isAdding, setIsAdding] = useState(false);

  const {
    isPending: userGroupAddressesIsPending,
    data: userGroupAddresses,
    error: userGroupAddressesError
  } = noddiAsync.useGet({
    type: URLKeys.getUserGroupAddresses,
    input: { userGroupId: userGroupId! }
  });

  if (userGroupAddressesIsPending) {
    return <NoddiLoadingScreenWithTrans />;
  }
  if (userGroupAddressesError) {
    return <ApiErrorMessageWithTrans error={userGroupAddressesError} />;
  }

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-center justify-between gap-4'>
        <h2 className='text-xl font-bold text-primary md:text-3xl'>
          <Trans>My addresses</Trans>
        </h2>
        <NoddiButton size='small' onClick={() => setIsAdding(true)}>
          {t`Add address`}
        </NoddiButton>
      </div>
      <div className='flex flex-col gap-2'>
        {userGroupAddresses.results.map((userGroupAddress) => (
          <Address key={userGroupAddress.id} userGroupAddress={userGroupAddress} userGroupId={userGroupId!} />
        ))}
      </div>
      {isAdding && <AddressDialog open={isAdding} onClose={() => setIsAdding(false)} userGroupId={userGroupId!} />}
    </div>
  );
};
